'use client';

import { ProgressProvider } from '@bprogress/next/app';

export const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <ProgressProvider
      height="4px"
      color="var(--color-brand-secondary)"
      shallowRouting
    >
      {children}
    </ProgressProvider>
  );
};
